export default __webpack_public_path__ + "static/media/icon_start.4c8d2fc0.svg";